<template>
  <div>
    <div class="description">
      <FadeRight appear :duration="500">
        <h1>{{ "&mdash;&nbsp;" + project.Title + "." }}</h1>
      </FadeRight>
      <transition-group
        appear
        :css="false"
        v-on:before-appear="beforeAppear"
        v-on:appear="appear"
      >
        <hr :key="1" :data-index="1" />
        <h3 :key="2" :data-index="2">{{ project.Client }}</h3>
        <hr :key="3" :data-index="3" />
        <h3 :key="4" :data-index="4">{{ project.Role }}</h3>
        <hr :key="5" :data-index="5" />
        <h3 :key="6" :data-index="6">{{ project.Year }}</h3>
      </transition-group>
      <!-- <p
        class="dropCap"
      >Watney is an architectural installation created for SXSW. Consisting of thirteen students, the studio both successfully fundraised for and built Watney. The resulting installation is conceived through inhabitation, constructability, and portability.</p>-->
    </div>
  </div>
</template>

<script>
import FadeRight from "@/transitions/FadeRight.vue";

export default {
  name: "WorksIntro",
  components: {
    FadeRight
  },
  props: {
    project: Object,
    projectId: Number
  },
  methods: {
    beforeAppear: function(el) {
      el.style.transform = "translateY(1rem)";
      el.style.opacity = 0;
    },
    appear: function(el, done) {
      let delay = el.dataset.index * 150;
      // console.log(el.dataset);
      el.addEventListener("transitionend", done, { once: true });
      setTimeout(function() {
        el.style.transform = "translateY(0)";
        el.style.opacity = 1;
      }, delay);
    }
  }
};
</script>

<style lang="scss" scoped>
// * {
//   border: 1px solid red;
// }

.description {
  // margin: 6.75rem auto !important;
  // position: fixed;
  h3,
  hr {
    transition: opacity 400ms ease-out 750ms, transform 400ms ease-out 750ms;
  }
  h1 {
    margin-left: -0.5rem;
    font-size: 3rem;
  }
  h3 {
    font-family: $text-font-stack;
    // text-transform: uppercase;
    color: $mid-grey;
    font-weight: 400;
    font-size: 1rem;
  }
  p {
    // font-size: 1.125rem;

    color: $dark-grey;
  }
}
</style>
